import { render, staticRenderFns } from "./MonitorService.vue?vue&type=template&id=19760939&scoped=true&"
import script from "./MonitorService.vue?vue&type=script&lang=js&"
export * from "./MonitorService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19760939",
  null
  
)

export default component.exports